import { render, staticRenderFns } from "./createMark.vue?vue&type=template&id=f5cd82ca&scoped=true"
import script from "./createMark.vue?vue&type=script&lang=js"
export * from "./createMark.vue?vue&type=script&lang=js"
import style0 from "./createMark.vue?vue&type=style&index=0&id=f5cd82ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cd82ca",
  null
  
)

export default component.exports